import ObjectModelRelation from "~/models/objectModelRelations/objectModelRelation";
import ModelMappingValueOrigin from "~/models/mapping/modelMappingValueOrigin";
import ObjectModelRelationDefinition from "~/models/objectModelRelations/objectModelRelationDefinition";
import {friendlyObjectRelationDisplay} from "~/enums/objectModelRelationType";

export default class ModelMappingValueOriginObjectModelRelation extends ModelMappingValueOrigin<ObjectModelRelation> {
  isSinglePicklist: boolean = false
  isMultiPicklist: boolean = false

  get origin(): ObjectModelRelation {
    return ObjectModelRelation.repo.find(this.id)
  }

  get value() {
    const omr = this.origin
    if (!omr) return null
    return ObjectModelRelationDefinition.mappingValueOption(omr)
  }

  get valueType(): string {
    const omr = this.origin
    if (!omr) return null
    return friendlyObjectRelationDisplay(omr.relation_type)
  }

  get isIndexed(): boolean {
    return false;
  }

  get isUploader(): boolean {
    return false;
  }

  get isBuiltIn(): boolean {
    return false;
  }

  get originType() {
    return this.origin?.relation_type
  }
}